import React from 'react';
import {
  HomeIcon,
  MagnifyingGlassIcon,
  BookOpenIcon,
  BeakerIcon,
  UserGroupIcon,
  ArrowsRightLeftIcon,
  QueueListIcon,
  PencilSquareIcon,
  InformationCircleIcon,
  SquaresPlusIcon,
  LightBulbIcon,
  MegaphoneIcon,
  PresentationChartBarIcon,
  ShareIcon,
  DocumentTextIcon,
  IdentificationIcon,
  BarsArrowDownIcon,
  LinkIcon,
  GlobeAltIcon,
  ClockIcon,
  TagIcon,
  SparklesIcon,
  AcademicCapIcon,
  ArrowPathIcon,
} from '@heroicons/react/24/outline';

// Mapeamento de nomes de ícones do backend para componentes React
const ICON_MAP: Record<string, React.ComponentType<any>> = {
  'HomeIcon': HomeIcon,
  'MagnifyingGlassIcon': MagnifyingGlassIcon,
  'BookOpenIcon': BookOpenIcon,
  'BeakerIcon': BeakerIcon,
  'UserGroupIcon': UserGroupIcon,
  'ArrowsRightLeftIcon': ArrowsRightLeftIcon,
  'QueueListIcon': QueueListIcon,
  'PencilSquareIcon': PencilSquareIcon,
  'InformationCircleIcon': InformationCircleIcon,
  'SquaresPlusIcon': SquaresPlusIcon,
  'LightBulbIcon': LightBulbIcon,
  'MegaphoneIcon': MegaphoneIcon,
  'PresentationChartBarIcon': PresentationChartBarIcon,
  'ShareIcon': ShareIcon,
  'DocumentTextIcon': DocumentTextIcon,
  'IdentificationIcon': IdentificationIcon,
  'BarsArrowDownIcon': BarsArrowDownIcon,
  'LinkIcon': LinkIcon,
  'GlobeAltIcon': GlobeAltIcon,
  'ClockIcon': ClockIcon,
  'TagIcon': TagIcon,
  'SparklesIcon': SparklesIcon,
  'AcademicCapIcon': AcademicCapIcon,
  'ArrowPathIcon': ArrowPathIcon,
};

/**
 * Mapeia um nome de ícone do backend para um componente React
 * @param iconName Nome do ícone do backend (ex: 'MagnifyingGlassIcon')
 * @returns Componente React do ícone ou null se não encontrado
 */
export function getIconComponent(iconName: string | null | undefined): React.ReactNode {
  if (!iconName) {
    return <MagnifyingGlassIcon className="w-6 h-6" />; // Ícone padrão
  }

  const IconComponent = ICON_MAP[iconName];
  
  if (!IconComponent) {
    return <MagnifyingGlassIcon className="w-6 h-6" />; // Ícone padrão
  }

  return <IconComponent className="w-6 h-6" />;
}

